import theme from '@styles/theme';
export default {
  section: {
    width: '100%',
    backgroundColor: theme.rawColors.lightGrey300,
    display: 'flex',
    justifyContent: 'center',
    p: '40px 20px 40px 20px'
  },
  container: {
    width: '100%',
    maxWidth: ['100%', '100%', 478, 903],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    h4: {
      fontFamily: theme.fonts.uniformExtra
    }
  },
  linkContainer: {
    width: '100%',
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    div: {
      width: ['calc(50% - 18px)', 'calc(50% - 18px)', 'calc(33.3% - 18px)', 'calc(33.3% - 18px)'],
      mr: 12,
      mb: 12,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      a: {
        width: '100%',
        height: 24,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    }
  }
};